import {
  DRAFT_APP,
  CHANGE_DRAFT_APP_STATE,
  UPDATE_DRAFT_APP,
} from '../../types';
import { DraftApps } from '@/api/api';

export default {
  state: () => ({
    draftApp: {},
  }),

  getters: {
    [DRAFT_APP]({ draftApp = {} }) {
      return draftApp;
    },
  },

  mutations: {
    [DRAFT_APP](state, draftApp) {
      state.draftApp = draftApp;
    },
    [UPDATE_DRAFT_APP](state, data) {
      state.draftApp = {
        ...state.draftApp,
        ...data,
      };
    },
  },

  actions: {
    [DRAFT_APP]({ commit }, id) {
      return DraftApps.get(id).then(({ draftApp = {} }) => {
        commit(DRAFT_APP, draftApp);
        return draftApp;
      });
    },

    [UPDATE_DRAFT_APP]({ commit }, data) {
      commit(UPDATE_DRAFT_APP, data);
    },

    [CHANGE_DRAFT_APP_STATE]({ commit, state }, { to, data }) {
      const { id, currentState } = state.draftApp;

      return DraftApps.changeState({
        id,
        currentState,
        nextState: to,
        data,
      }).then(({ draftApp }) => {
        commit(DRAFT_APP, draftApp);
        return draftApp;
      });
    },
  },
};
